import { useState } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';
import FeatureAnnouncementBaseModal from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseModal';
import FeatureAnnouncementBaseLayout from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncementBaseLayout';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { FeatureAnnouncementModalPageConfig } from 'src/components/Modals/FeatureAnnouncementModal/types';
import {
	FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH,
	FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH,
} from 'src/components/Modals/FeatureAnnouncementModal/consts';

const S3_BUCKET_PATH = `${FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH}/per-market-leverage`;
const PREVIEW_IMAGE_PATH = `${FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH}/per-market-leverage`;

const PER_MARKET_LEVERAGE_PAGES_CONFIG: FeatureAnnouncementModalPageConfig[] = [
	{
		title: 'Trade with Custom Leverage Per Market',
		description:
			'Set leverage per market, not across your entire account. Choose your preferred leverage for each market to customise your exposure.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/custom-leverage.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/custom-leverage.webp`,
		},
		mobileMedia: {
			type: 'image',
			src: `${S3_BUCKET_PATH}/first-page-mobile.webp`,
		},
	},
	{
		title: 'Adjust Leverage with ease',
		description:
			'Adjust your leverage for each market. Your custom leverage applies to all open positions and orders in that specific market.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/adjust-leverage.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/adjust-leverage.webp`,
		},
		mobileMedia: {
			type: 'image',
			src: `${S3_BUCKET_PATH}/second-page-mobile.webp`,
		},
	},
	{
		title: 'Adjust your Position Size',
		description:
			'Use the slider to allocate available collateral to a new position. Your position sizes scales with the leverage you’ve chosen. ',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/adjust-position.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/adjust-position.webp`,
		},
		mobileMedia: {
			type: 'image',
			src: `${S3_BUCKET_PATH}/third-page-mobile.webp`,
		},
	},
	{
		title: 'Understand your Initial Margin',
		description:
			'See how much collateral is used to open your position. Your initial margin amount adjusts with your leverage.',
		desktopMedia: {
			type: 'video',
			src: `${S3_BUCKET_PATH}/understand-initial-margin.webm`,
			previewImgSrc: `${PREVIEW_IMAGE_PATH}/understand-initial-margin.webp`,
		},
		mobileMedia: {
			type: 'image',
			src: `${S3_BUCKET_PATH}/fourth-page-mobile.webp`,
		},
	},
];

export const FeatureAnnouncementPerMarketLeverageModal = () => {
	const { hide } = useModal();
	const isMobileScreenSize = useIsMobileScreenSize();

	const [currentStep, setCurrentStep] = useState(0);

	const currentPageConfig = PER_MARKET_LEVERAGE_PAGES_CONFIG[currentStep];

	return (
		<FeatureAnnouncementBaseModal
			announcementName="perMarketLeverage"
			title="Custom Leverage Per Market"
			onClose={hide}
			currentStep={currentStep}
			setCurrentStep={setCurrentStep}
			showBackButton={currentStep > 0}
			pagesConfig={PER_MARKET_LEVERAGE_PAGES_CONFIG}
		>
			<FeatureAnnouncementBaseLayout
				title={currentPageConfig.title}
				description={currentPageConfig.description}
				media={{
					...(isMobileScreenSize
						? currentPageConfig.mobileMedia
						: currentPageConfig.desktopMedia),
				}}
				mediaLoadingHeight={
					isMobileScreenSize ? 'calc((100vw - 32px) * 0.76)' : 325.2
				}
				step={currentStep}
				totalSteps={PER_MARKET_LEVERAGE_PAGES_CONFIG.length}
			/>
		</FeatureAnnouncementBaseModal>
	);
};
